const PREFIX = "/reducres/userProfile/";

export const SET_USER_PROFILE = `${PREFIX}SET_USER_PROFILE`;
export const IS_REQUESTING = `${PREFIX}IS_REQUESTING`;
export const UPDATE_USER_NAME_AND_GENDER = `${PREFIX}UPDATE_USER_NAME_AND_GENDER`;
export const SET_REFERRALS_DATA = `${PREFIX}SET_REFERRALS_DATA`;
export const UPDATE_BABY_DOB = `${PREFIX}UPDATE_BABY_DOB`;
export const CLEAR_USER_PROFILE = `${PREFIX}CLEAR_USER_PROFILE`;
